import React from "react";
import { connect } from "react-redux";
import {injectIntl, FormattedMessage} from "react-intl";
import isObject from "lodash/isObject";

import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";

import WithOverlay from "../../popups/withOverlayHoc";
import {changeMessageBoxState} from "../../../actions/actionFunctions";
// import WithLoginPostMessage from "../hocs/withLoginPostMessage";
// import {LIXIL_USER_QUERY_PARAMS} from "../../../api/look-api";

const LookMessageBoxPopup = (props) => {

  const {messageBoxState, intl, changeMessageBoxState} = props;
  const {visible, message, title, type} = messageBoxState;

  if (!visible) {
    return null
  }

  const getMessage = () => {
    if (Array.isArray(message)) {
      return message.map((msg, msgIndex) => <p key={"msg"+msgIndex}>{msg}</p>)
    } else if (isObject(message)) {
      return message.id ? <FormattedMessage id={message.id} values={{...message}}/> : message
    } else if (message) { //string
      return intl.messages[message]
        ? <FormattedMessage id={message}/>
        : message.replace("Zip", "Postal").replace("Server error: ", "")
    } else {
      return "Error";
    }
  };

  const closePopup = () => {
    changeMessageBoxState({visible: false})
  }

  const renderButton = (hideOverlay) => {
    switch (type) {
      // case "sessionExpired": {
      //   const searchParams = new URLSearchParams(
      //     (window.location.search).replace(/amp;/g, "")
      //     || (window.location.hash).replace(/(.*)\?/g, "")
      //     || ""
      //   );
      //   LIXIL_USER_QUERY_PARAMS.forEach(param => searchParams.delete(param));
      //   const returnUrl = window.location.origin + window.location.pathname + searchParams.toString();
      //   console.log("returnUrl", returnUrl);
      //   return (
      //     <WithLoginPostMessage>
      //       {(loginPostMessage) => (
      //         <Button className={"look-button look-button--primary look-button--min"}
      //                 onClick={() => {
      //                   hideOverlay(closePopup);
      //                   loginPostMessage(returnUrl);
      //                 }}>
      //           <FormattedMessage id="buttons.login"/>
      //         </Button>
      //       )}
      //     </WithLoginPostMessage>
      //   )
      // }
      default:
        return (
          <Button className={"look-button look-button--primary look-button--min"}
                  onClick={() => hideOverlay(closePopup)}>
            <FormattedMessage id="iconButton.close"/>
          </Button>
        )

    }
  }

  return (
    <WithOverlay closePopup={closePopup} className="overlay--top">
      {(hideOverlay) => (
        <div className="look-popup look-popup--wishlist">
          <IconButton aria-label={intl.formatMessage({id:"iconButton.close"})}
                      className="look-icon look-icon--small look-popup__close"
                      onClick={() => hideOverlay(closePopup)}>
            <CloseIcon/>
          </IconButton>
          <div className="look-popup__content">
            {/*<IconButton aria-label={intl.formatMessage({id:"tooltip.wishlist"})}*/}
            {/*            className={"look-icon look-icon--large look-icon--disabled--hover"}*/}
            {/*            disabled={true}>*/}
            {/*  */}
            {/*</IconButton>*/}
            <p className="look-popup__content-title look-popup__content-title--with-icon">
              <InfoIcon /> <span className="look-popup__content-title-text">
                {title ? intl.formatMessage({id: title}) : "Server error"}
              </span>
            </p>
            <p className="look-popup__content-description">{getMessage()}</p>
            {renderButton(hideOverlay)}
          </div>
        </div>
      )}
    </WithOverlay>
  )
};

const mapStateToProps = (store) => {
  return {
    messageBoxState: store.messageBoxState,
  };
};

const mapDispatchToProps = {
  changeMessageBoxState
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookMessageBoxPopup)
)
